// Todas as definições do tema
// Algumas especificas para a biblioteca Vuetify que é utilizada
// outras especificas para áreas internas do sistema, como o caso
// do menu

import colors from 'vuetify/es5/util/colors';

const baseColors = {
  primary: colors.blue.darken4,
  secondary: colors.indigo.base,
  tertiary: colors.blue.lighten3,
  error: colors.red.darken3,
  info: colors.teal.lighten2,
  success: colors.green.base,
  warning: colors.amber.accent3,
};

baseColors.accent = baseColors.secondary;

export default {
  baseColors,
  menu: {
    bodyClass: 'secondary darken-1',
    headerClass: 'primary',
    activeItemClass: 'tertiary--text',
    darkMode: true,
  },
};



// WEBPACK FOOTER //
// ./src/Theme.js